// Fallback inspirational quotes used when the remote quotes API is unreachable.
// Picked deterministically by day-of-year so the same quote shows all day.
export const FALLBACK_QUOTES = [
  {
    text: "Justice delayed is justice denied.",
    author: "William E. Gladstone",
  },
  {
    text: "The first duty of society is justice.",
    author: "Alexander Hamilton",
  },
  {
    text: "An unjust law is itself a species of violence.",
    author: "Mahatma Gandhi",
  },
  { text: "Where law ends, tyranny begins.", author: "John Locke" },
  { text: "The law is reason, free from passion.", author: "Aristotle" },
  {
    text: "We are what we repeatedly do. Excellence, then, is not an act, but a habit.",
    author: "Aristotle",
  },
  {
    text: "Success is not final, failure is not fatal: it is the courage to continue that counts.",
    author: "Winston Churchill",
  },
  {
    text: "The only way to do great work is to love what you do.",
    author: "Steve Jobs",
  },
  { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
  {
    text: "Discipline is the bridge between goals and accomplishment.",
    author: "Jim Rohn",
  },
  {
    text: "An investment in knowledge pays the best interest.",
    author: "Benjamin Franklin",
  },
  {
    text: "Whether you think you can or you think you can't, you're right.",
    author: "Henry Ford",
  },
  {
    text: "In the middle of difficulty lies opportunity.",
    author: "Albert Einstein",
  },
  {
    text: "The journey of a thousand miles begins with a single step.",
    author: "Lao Tzu",
  },
  {
    text: "He who has a why to live for can bear almost any how.",
    author: "Friedrich Nietzsche",
  },
  {
    text: "It is not the strongest of the species that survives, but the most adaptable.",
    author: "Charles Darwin",
  },
  {
    text: "Patience is bitter, but its fruit is sweet.",
    author: "Jean-Jacques Rousseau",
  },
  { text: "Happiness depends upon ourselves.", author: "Aristotle" },
  { text: "The unexamined life is not worth living.", author: "Socrates" },
  { text: "What we think, we become.", author: "Buddha" },
];

export function dayOfYear(d: Date = new Date()) {
  const start = new Date(d.getFullYear(), 0, 0);
  const diff = (d as any) - (start as any);
  return Math.floor(diff / 86400000);
}

export function getFallbackQuote() {
  const idx = dayOfYear() % FALLBACK_QUOTES.length;
  return FALLBACK_QUOTES[idx];
}
